import React from "react";
import { Modal } from "react-bootstrap";
import { ReactComponent as SuccessIcon } from "static/images/success-icon.svg";

import "./successModal.scss";

const SuccessModal = () => {
	return (
		<Modal
			className="special_modal statusModal"
			backdrop={false}
			show={true}
			size="sm"
		>
			<Modal.Body>
				<div className="bodyContent">
					<div className="statusIcon">
						<div className="circleSuccess">
							<SuccessIcon />
						</div>
					</div>
					<h1 className="statusMessage">
						Application was successfully submitted
					</h1>
					<div className="statusHelpText">
						<p>
							Our sales representative may contact with you for
							additional details.
						</p>
						<p>
							After application is processed you will receive an
							email to sign documents.
						</p>
					</div>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<a className="supportLink" href="tel:1-833-AURORA2">
					Need help? Call us at 1-833-AURORA2
				</a>
			</Modal.Footer>
		</Modal>
	);
};

export default SuccessModal;
